import {useEffect} from 'react';
import styles from './style.module.css';

const AccordionButton = () => {
  useEffect(() => {
    const buttons = document.querySelectorAll<HTMLButtonElement>(
      'button.accordion-button'
    );
    const containers = document.querySelectorAll<HTMLElement>(
      'div.cms-links-container'
    );

    containers.forEach((container, index) => {
      container.style.display = 'none';
      console.log(`Container ${index} display set to none initially.`);
    });

    buttons.forEach((button, index) => {
      const linkContainer = containers[index];

      if (!linkContainer) {
        console.error(
          `No corresponding .cms-links-container found for button at index ${index}.`
        );
        return;
      }

      button.classList.add(styles.accordionButton, 'collapsed');

      let isVisible = false;

      const toggleLinks = () => {
        isVisible = !isVisible;
        console.log(
          `Button ${index} clicked. Setting display to: ${
            isVisible ? 'block' : 'none'
          }`
        );

        linkContainer.style.display = isVisible ? 'block' : 'none';

        if (isVisible) {
          button.classList.remove('collapsed');
          button.classList.add(styles.accordionButtonOpen);
          linkContainer.classList.add(styles.cmsLinksContainerOpen);
        } else {
          button.classList.add('collapsed');
          button.classList.remove(styles.accordionButtonOpen);
          linkContainer.classList.remove(styles.cmsLinksContainerOpen);
        }
      };

      button.addEventListener('click', toggleLinks);

      return () => {
        button.removeEventListener('click', toggleLinks);
      };
    });
  }, []);

  return null;
};

export default AccordionButton;
